import React from 'react';
import Icon from '@atlaskit/icon';
var CustomGlyph = function CustomGlyph() {
  return /*#__PURE__*/React.createElement("svg", {
    width: "24",
    height: "24",
    fill: "none",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "currentColor",
    clipPath: "url(#clip0_654_431)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 4h-1v16h1V4ZM3 8a1 1 0 0 1 1-1h9.5a4.5 4.5 0 1 1 0 9h-2.086l.293.293a1 1 0 0 1-1.414 1.414l-2-2a1 1 0 0 1 0-1.414l2-2a1 1 0 0 1 1.414 1.414l-.293.293H13.5a2.5 2.5 0 0 0 0-5H4a1 1 0 0 1-1-1Z",
    clipRule: "evenodd",
    fillRule: "evenodd"
  })));
};
export var WrapIcon = function WrapIcon() {
  return /*#__PURE__*/React.createElement(Icon, {
    glyph: CustomGlyph,
    label: "wrapIcon"
  });
};